/**
 * Editorial how-to + FAQ block for F1 tool pages. Data-heavy pages (optimizer
 * tables, price grids) look substantial to a word counter but show a reviewer
 * zero explanatory prose — this section is what keeps them monetizable.
 */
export function F1Explainer({
  title,
  howTo,
  faqs,
}: {
  title: string;
  howTo: string;
  faqs: Array<{ q: string; a: string }>;
}) {
  return (
    <section className="max-w-3xl mx-auto px-5 py-10 space-y-8">
      <div className="space-y-3">
        <h2 className="font-display text-2xl font-bold tracking-tight">
          {title}
        </h2>
        {howTo.split("\n\n").map((p) => (
          <p key={p} className="leading-relaxed text-muted-foreground">
            {p}
          </p>
        ))}
      </div>
      <dl className="space-y-3">
        {faqs.map((f) => (
          <div
            key={f.q}
            className="rounded-xl border border-border bg-card/40 p-4"
          >
            <dt className="font-semibold text-foreground">{f.q}</dt>
            <dd className="mt-1.5 text-sm leading-relaxed text-muted-foreground">
              {f.a}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
